import { ClientBookingConfirmation } from "../../ClientBookingConfirmation";
import { AssistantBookingScope } from "./AssistantBookingScope";

/**
 * Assistant-scoped booking confirmation (DEV-1296). Same scope + banner as the booking sheet; the
 * banner keeps naming the client the finished booking belongs to, and the shared confirmation's
 * CTAs stay scoped to that client. Mirrors OperatorClientBookingConfirmation.
 */
export const AssistantClientBookingConfirmation = () => (
  <AssistantBookingScope>
    <ClientBookingConfirmation />
  </AssistantBookingScope>
);
